import { render, staticRenderFns } from "./InviteNewCollaboratorListCell.vue?vue&type=template&id=aeceb0cc&scoped=true"
import script from "./InviteNewCollaboratorListCell.vue?vue&type=script&lang=js"
export * from "./InviteNewCollaboratorListCell.vue?vue&type=script&lang=js"
import style0 from "./InviteNewCollaboratorListCell.vue?vue&type=style&index=0&id=aeceb0cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeceb0cc",
  null
  
)

export default component.exports